import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import { identity } from 'ramda'
import InputMask from 'react-input-mask'

import Field from '../Field'

const TextInputMask = forwardRef(
  (
    {
      beforeMaskedValueChange,
      maskChar,
      alwaysShowMask,
      autoComplete,
      ...rest
    },
    ref
  ) => (
    <Field
      {...rest}
      render={(renderProps) => (
        <InputMask
          {...renderProps}
          maskChar={maskChar}
          alwaysShowMask={alwaysShowMask}
          beforeMaskedValueChange={beforeMaskedValueChange}
        >
          {(inputProps) => (
            <input autoComplete={autoComplete} ref={ref} {...inputProps} />
          )}
        </InputMask>
      )}
    />
  )
)

TextInputMask.defaultProps = {
  maskChar: null,
  alwaysShowMask: false,
  beforeMaskedValueChange: identity,
  autoComplete: 'on',
}

TextInputMask.propTypes = {
  className: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  mask: PropTypes.string,
  label: PropTypes.string,
  hint: PropTypes.string,
  tooltip: PropTypes.string,
  maskChar: PropTypes.string,
  alwaysShowMask: PropTypes.bool,
  beforeMaskedValueChange: PropTypes.func,
  autoComplete: PropTypes.oneOf(['on', 'off']),
}

export default TextInputMask
